var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollaspRight = function SvgCollaspRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#868E96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.667 9 2.8-3.36c.255-.306.382-.459.382-.64s-.127-.334-.382-.64L5.667 1M1 9l2.8-3.36c.255-.306.382-.459.382-.64s-.127-.334-.382-.64L1 1"
  })));
};
export default SvgCollaspRight;